import { Component, OnInit , Input } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {SetwindowComponent} from 'src/app/common/ngbmodel/setwindow/setwindow.component'
import { ActivatedRoute } from '@angular/router';
import { EditComponent } from 'src/app/common/ngbmodel/edit/edit.component';
import { TranslateCompiler } from '@ngx-translate/core';
import { districtsdata ,setDropDown} from 'src/assets/i18n/hi.json';
@Component({
  selector: 'app-extension-approval',
  templateUrl: './extension-approval.component.html',
  styleUrls: ['./extension-approval.component.css']
})
export class ExtensionApprovalComponent implements OnInit {

  @Input() selectedlanguage:string;
  yearDropDownList : [];
  assesmentyear;
  setwindowparams : object = {assessmentyear : '',sdate : null,edate : null,statearray : []};
  showtable : boolean = false;
  stateDropDownList;
  selecteddistrict : any;
  DistrictDropDownList;
  distuuid = null
  stateuuid = null
  statearray;
  selectedStateIds;
  selectedstate : any;
  modalRef : any;
  tableData = {}
  windowdata;
  enablesetwindow : boolean;
  windowtabledata = {};
  activesidetab;
  startDateminDate;
  startDatemaxDate;
  endDateminDate;
  endDatemaxDate;
  shownodata : boolean = false;
  dateformat = {value: 'yyyyMMdd'}
  activeSpinner : boolean = false;
  dropdownSettings: any = {
    singleSelection: false,
    idField: 'uuid',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailable: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  hindidropdownSettings: any = {
    singleSelection: false,
    idField: 'uuid',
    textField: 'naam',
    selectAllText: setDropDown.selectAllText,
    unSelectAllText: setDropDown.unSelectAllText,
    noDataAvailable: setDropDown.noDataAvailable,
    itemsShowLimit: 2,
    allowSearchFilter: true
  };
  dropdownSetting: any = {
    singleSelection: false,
    idField: 'uuid',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  validation: boolean[] = new Array(6).fill(true);
  userdetails: any;
  state_nodal_officer: any;
  dist_nodal_officer: string;
  districtflag: any;
  urlparams: object;
  usertab: any;
  DistrictList: any[];
  DistrictDropdownlist: any;
  districtarray: any[];
  admin_officer: string;
  subTp:any
  setYear="2020-2021";
  monthList = {
    '04': 'April',
    '05':'May',
    '06': 'June',
     '07':'July',
     '08':'August',
     '09':'September',
    '10': 'October',
     '11':'November',
     '12': 'December',
     '01':'January',
    '02': 'February',
     '03':'March',
 
  };
  // monthList:any = [
  //   { key: '04' ,value: 'April'},
  //   { key: '05' ,value:'May'},
  //   { key: '06' ,value: 'June'},
  //   { key: '07' ,value:'July'},
  //   { key: '08' ,value: 'August'},
  //   { key: '09' ,value:'September'},
  //   { key: '10' ,value: 'October'},
  //   { key: '11' ,value:'November'},
  //   { key: '12' ,value: 'December'},
  //   { key: '01' ,value:'January'},
  //   { key: '02' ,value: 'February'},
  //   { key: '03' ,value:'March'},
  // ];

  monthlist:{key: string, value:string}[] = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
   
    ];
  selectedMonth: any
  stateArrayList: any[];
  statelists: any[];
  filterdistrict: any;
  showdistdrop: boolean;
  firstItemEntered:boolean=false;
  itemSelectCount=0;
  selectedDistrictId: any[];
  districtTranslate: any[];
  distSelectCount=0;
  firstdistEntered:boolean=false;

  constructor(private submitdataservice : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private toastr : ToastrService,
    private route: ActivatedRoute,
    private logsrv : AuthloginService,
    private modalService : NgbModal) { }

  ngOnInit() {
    this.submitdataservice.getStatusOfToken();
    this.initonload();
    this.navtabclick('setwindow');
  }
  initonload(){
    this.assesmentyear = '';
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
      this.getWindowStatusAdmin();
      this.getWindowStatus();
    });
    this.statearray = [];
    this.showtable = false;    
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    // console.log("cfhgchvhj",this.state_nodal_officer,this.userdetails['roles'][0])
    this.dist_nodal_officer  = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER'];
    this.admin_officer =  this.constants.USER_TYPES['ADMIN'];
    this.urlparams = this.submitdataservice.getWritableObject(this.route.snapshot.params)
    this.usertab = this.urlparams['component'];
    this.userdetails = this.logsrv.checkloginstatus();
    this.getstateslist();
    // if(this.admin_officer  != this.userdetails['roles'][0]){
    // this.getLocationForDistrict();
    // }
    // this.get
    this.setwindowparams = {assessmentyear : '',sdate : null,edate : null,statearray : []};
  }
  public navtabclick(type){
    this.showtable = false;
    if(type == this.activesidetab)
     return
    this.activesidetab = type;
    this.initonload()
  }
  setYearList(value){
    this.setYear=value;
  }
  getstateslist(){
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.stateArrayList.push(statelist);
            this.stateArrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);
  
          });
        })
      }
    })
  
  }

  async getWindowStatus(){
    this.windowtabledata = {};
    this.enablesetwindow = false;
    this.activeSpinner = true;
    let options = {};
    options["isLocationNeeded"] =  false
    // options['pEUUID'] = this.state_nodal_officer == this.userdetails['roles'][0] ? this.userdetails['loggedUserData']['userProfile']['stateUUID']: this.userdetails['loggedUserData']['userProfile']['locationId']
    // options["yearlist"] = this.submitdataservice.getassesmentYear(),
    if(this.userdetails['roles'][0]==this. admin_officer){
      options['pEUUID']="null";
    }else if(this.userdetails['roles'][0]==this.state_nodal_officer){
      options['pEUUID']=this.userdetails['loggedUserData']['userProfile']['stateUUID'];
    }else{
      options['pEUUID']= this.userdetails['loggedUserData']['userProfile']['locationId'];
    }
    options["yearlist"] = this.submitdataservice.getassesmentYear();
    options["view"] =  this.constants.VIEWS['admin'],
    options["cType"] = this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['DISTRICT']
    options["monthlist"]=this.submitdataservice.getMonthList();
    options["yearlist"] = this.yearDropDownList;
    this.showtable = true;
    this.windowdata = await this.submitdataservice.getWindowStatus(options);
    Object.keys(this.windowdata).forEach(year =>{
    if(!this.windowdata[year].hasOwnProperty("status") && year != "2015-2016" && year != "2016-2017" && year != "2017-2018"){
      
      this.windowtabledata[year] =  this.windowdata[year]
    } else {
      this.enablesetwindow = true;
    }
    if(Object.keys(this.windowtabledata).length == 1){
      this.enablesetwindow = false;
    }
    if(Object.keys(this.windowtabledata).length == 0){
      this.shownodata = true
    } else {
      this.shownodata = false
    }
    this.activeSpinner = false;
  });
  }
  getYearAndMonth(year,index){
    let arr=year.split("#");
      arr[1]=this.monthList[arr[1]];
      return (arr && (arr.length-1>=index) && arr[index])?arr[index]:"-"
  }
//   
  getLocationList(){
    let option = {};
    this.stateDropDownList = [];
    console.log("cfhgchvhj",this.state_nodal_officer,this.userdetails['roles'][0])
    option['pType'] = this.admin_officer  == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['BASIN'] : this.constants.LOCATION_CONSTANT['STATE']
    option['cType'] = this.admin_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT']
    // option['puuid'] = this.constants['COUNTRYUUID']
    // option['type'] = type;
    option["component"] = "";
    option["src"] = "";
    this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data =>{
      if(data){
        // var data = this.submitdataService.getLocationList();
        let statedata = []
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            statedata.push(list);
          });
        });
        this.stateDropDownList = this.formatListForMultiDropDown(statedata);
        // this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
        if(this.admin_officer  == this.userdetails['roles'][0]){
        this.getLocationForDistrict();
        }

      }
      else
       this.stateDropDownList = [];
      this.activeSpinner = false;
  },function(err){
    console.log("error"); 
      this.activeSpinner = false;
      if(err['error']){
        this.toastr.error(err['error']['msg'])
      }
    });
}
async getWindowStatusAdmin(){
  this.windowtabledata = {};
  this.enablesetwindow = false;
  this.activeSpinner = true;
  let options = {};
  options["isLocationNeeded"] =  false
  options['pEUUID'] = "null";
  // options["yearlist"] = this.submitdataservice.getassesmentYear(),
  console.log("admin yer",this.yearDropDownList);
  options["view"] =  this.constants.VIEWS['admin'];
  options["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT'];
  options["monthlist"]=this.submitdataservice.getMonthList();

  this.showtable = true;
this.windowdata = await this.submitdataservice.getWindowStatus(options);

}
getLocationForDistrict(){
  this.DistrictDropDownList = [];
  let option = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    // 'puuid': this.userdetails['loggedUserData']['userProfile']['stateUUID']
    'puuid':this.statearray[0]['item_id']
  };
  this.activeSpinner = true;
  this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
    if(Array.isArray(data)){
      this.DistrictDropDownList = data;
      console.log(this.DistrictDropDownList)
    }
    else
     this.DistrictDropDownList = [];
    this.activeSpinner = false;
},function(err){
  console.log("error"); 
    this.activeSpinner = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  });
}
showdistrictdropdown(stateuuid){
  this.removeItem({},'all');
  this.filterdistrict = stateuuid;
  if(stateuuid){
    this.showdistdrop = true;
  } else{
    this.showdistdrop = false;
  }
  if(this.showdistdrop){
    this.getalldistDetails();
  }
}
getalldistDetails(){
  this.DistrictList = [];
  this.distuuid = "null"
  let option = {
    'pType':this.constants.LOCATION_CONSTANT['STATE'],
    'cType':this.constants.LOCATION_CONSTANT['DISTRICT'],
    'puuid': this.filterdistrict
  };
  this.activeSpinner = true;
  this.submitdataservice.getLocationListforUser(option).subscribe(data =>{
    this.activeSpinner = false;
    // if(Array.isArray(data)){
    //   this.DistrictList = data;
    //   console.log('data----',data);
    //   this.DistrictList=this.formatDistrcitList(data);
    //   this.DistrictList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    // }
    this.districtTranslate=[];
    this.DistrictList=this.formatDistrcitList(data);
    this.DistrictList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    
    // else
    //  this.fieldDropDownList['DistrictList'] = [];
    
},function(err){
    this.activespineer = false;
    if(err['error']){
      this.toastr.error(err['error']['msg'])
    }
  })
}
formatDistrcitList(data){
  data.forEach(dist=>{
    // console.log("dist",dist); 
    let obj={'name':"",'uuid':"",'naam':""};
    obj['uuid']=dist['uuid'];
    obj['name']=dist['name'];
    obj['naam']=districtsdata[obj['name']];
    this.districtTranslate.push(obj);
  })
  return this.districtTranslate;
}
formatListForMultiDropDown(data:any): any{
  let result = [];
    for(let i = 0; i < data.length; i++){
      if(!data[i]) continue;
      let item = {};
      item['item_id'] = data[i]['uuid'];//id++;
      item['item_text'] = data[i]['name'];
      result.push(item);
    }
    result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);

  console.log(data,result)
  return result;
}
onItemSelect(item: any) {
  let a=[];
  a[0]=item;
  this.addItem(a,'');
  // this.addItem(item,'');
  this.getLocationForDistrict();

}
onItemDeSelect(item: any) {
  let a=[];
  a[0]=item;
  this.removeItem(a,'');
  //this.removeItem(item,'');
}
onItemDeSelectAll(items: any) {
  this.removeItem(items,'all');
}
onSelectAll(items: any) {
  this.addItem(items,'all');
}
addItem(item,option){
  console.log('item',item);
  if(option == 'all'){
   this.statearray = [];
   this.selectedDistrictId=[]
  }
  
  else if(option==''&& (this.firstItemEntered==false)){
    this.firstItemEntered=true;
    this.statearray = [];
    this.selectedDistrictId=[];
  }
  for (let i = 0; i < item.length; i++) {
    let itemobj={};
    if (item[i]['naam']){
      itemobj=item[i];
      this.districtTranslate.forEach(obj=>{
        if(item[i]['naam']==obj['naam'])
        {
          itemobj['name']=obj['name'];
          item[i]=itemobj;
          console.log('-----itemobj------',itemobj);
        }

      })  
    }
    else{
      itemobj=item[i];
      this.districtTranslate.forEach(obj=>{
        if(item[i]['name']==obj['name'])
        {
          itemobj['naam']=obj['naam'];
          item[i]=itemobj;
          console.log('-----itemobj------',itemobj);
        }

      })  
    }
    this.statearray.push(item[i]);
    this.selectedDistrictId.push(item[i].uuid);
    this.itemSelectCount=this.itemSelectCount + 1;
  }
  // for (let i = 0; i < item.length; i++) {
  //   this.statearray.push(item[i]);
  // } 
}
removeItem(item,option){
  if(option == 'all'){
    this.statearray = [];
    this.selectedDistrictId=[];
    this.selecteddistrict="";
   }else{
  for(let i=0; i<this.statearray.length;i++){
    for(let j=0; j<item.length;j++){
     if(this.statearray[i]['uuid'] == item[j]['uuid']){
      this.statearray.splice(i, 1)
     }
    }
  }
  for(let i=0; i<this.itemSelectCount;i++){
    for(let j=0; j<item.length;j++){
     if(this.selectedDistrictId[i] == item[j]['uuid']){
      this.selectedDistrictId.splice(i, 1);
      this.itemSelectCount=this.itemSelectCount - 1;
     }
    }
  }
  }
}
onItemSelects(item: any) {
  this.addItem(item,'');
}
onItemDeSelects(item: any) {
  this.removeItem(item,'');
}
onItemDeSelectAlls(items: any) {
  this.removeItem(items,'all');
}
onSelectAlls(items: any) {
  this.addItem(items,'all');
}
addItems(item,option){
  if(option == 'all'){
   this.districtarray = [];
  }
  for(let i=0; i<item.length;i++){
        this.districtarray.push(item[i]);
  }
}
removeItems(item,option){
  if(option == 'all'){
    this.districtarray = [];
   }else{
  for(let i=0; i<this.districtarray.length;i++){
    for(let j=0; j<item.length;j++){
     if(this.districtarray[i]['uuid'] == item[j]['uuid']){
      this.districtarray.splice(i, 1)
     }
    }
  }
  }
}

selectOption(month){
  this.selectedMonth= month;
  console.log("month changed",this.selectedMonth);
  }
  
getbasicparams(){
  console.log(this.districtflag)
  let postdata = {};
  postdata['ay'] = this.submitdataservice.getassesmentYear(),
  postdata['view'] = this.constants.VIEWS['admin'];
  postdata['component'] = this.constants.COMPONENT['ACTUAL_DATA'];
  postdata["cType"] = this.districtflag ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE'];
  postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
  postdata['userType'] = this.userdetails['roles'][0];
  postdata["lu"] =  (this.urlparams['component'] == 'approvals' ? ((this.stateuuid && this.stateuuid != 'null') ? (this.districtflag ? (this.distuuid != 'null' ? this.distuuid : null) : this.stateuuid ) : null) :
    (this.districtflag ? this.distuuid : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']))
  return postdata;
}

  getTableData(){
    this.tableData = {};
    // if(this.basicvalidation()){
      this.showtable = true;
      this.activeSpinner = true;
      let postdata = {}
        postdata["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT'],
        postdata["view"] = this.constants.VIEWS['admin'],
        postdata["ay"] = this.assesmentyear,
        postdata["clist"] = this.selectedDistrictId;//this.setdistrictuuids(this.DistrictList)
        postdata["subTp"]=this.selectedMonth;
      this.submitdataservice.getrequestlist(postdata).subscribe(data =>{
        this.tableData = data;
        if(Object.keys(this.tableData).length == 0){
          this.shownodata = true
        } else {
          this.shownodata = false
        }
        this.activeSpinner = false;
      })
    }
  approveOrrejectclick(action){
    console.log(this.tableData);
    let entityList = this.formatdataforbackend();
    if(entityList.length > 0){
      this.activeSpinner = true;
      let postdata = {};
      postdata = {
        "ay": this.assesmentyear,
        "cType": this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
        "view": this.constants.VIEWS['admin'],
        "isAccepted": action == 'approve' ? true : false,
        "locdata": entityList,
        "subTp":this.selectedMonth
      }
      let actionmsg = this.constants.ACTIONMSG[action];
      let erroractionmsg = this.constants.ERRORACTIONMSG[action];
      let filetype = this.constants.FILETYPE['report'];
      this.submitdataservice.acceptwindowrequest(postdata).subscribe(data =>{
        console.log(data);
        if(data['status']){
          if(action)
            this.toastr.success(actionmsg +' '+(entityList.length)+ ' records successfully');
          else 
            this.toastr.success(filetype + ' ' + actionmsg);
          this.getTableData();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while "+erroractionmsg +" record's")
        }
        this.activeSpinner = false;
      });
    } else {
      this.toastr.error('Please select atleast one record')
    }
  }
  formatdataforbackend(){
    let array = [];
    Object.keys(this.tableData).forEach(uuid => {
      if(this.tableData[uuid]['ischecked']){
        array.push({"lu" : uuid,"proposeddate" : this.tableData[uuid]['extensiondate']})
      }
    });
    return array;
  }
  basicvalidation(){
    this.validation[0] = this.utils.checkfield(this.assesmentyear)
    this.validation[1] = this.utils.checkarrayfield(this.statearray)
    return this.validation[0] && this.validation[1]
  }
  formatdate(date){
    return this.utils.getDateInFormatFromModelDate(date.toString(),"dd-MM-yyyy")
  }
  checkallset(checkall){
    console.log(checkall)
    Object.keys(this.tableData).forEach(element=>{
      console.log(element,this.tableData[element])
      this.tableData[element]['ischecked'] = checkall ? true : false;
    })
    // this.tableData.forEach(element=>{
    //     element['ischecked'] = checkall ? true : false;
    // });
  }
 

  setstateuuids(data){
    let array = [];
    data.forEach(element => {
      array.push(element.uuid)
    });
    return array;
  }
  setdistrictuuids(data){
    let array = [];
    data.forEach(element => {
      array.push(element.uuid)
    });
    return array;
  }
  openwindowmodel(year){
    this.modalRef = this.modalService.open(SetwindowComponent,{ backdrop: 'static',windowClass: 'backgroundTransparent  approvalinfo'});
    this.modalRef.componentInstance.singleyear = year;
    this.modalRef.componentInstance.windowdata = this.windowdata;
    this.modalRef.componentInstance.emitService.subscribe((emmitedValue) => {
      console.log("emitted value",emmitedValue);
      this.subTp=emmitedValue['subTp'];
      console.log("subtp value",this.subTp);
      this.getWindowStatus();

      // do sth with emmitedValue
  });
    this.modalRef.result.then((result) => {
      // console.log(result,"pascollllena")
    //   if(result == 'load')
    // }, (reason) => {
  
    });
  }
  openEditmodel(year){
    this.modalRef = this.modalService.open(EditComponent,{ backdrop: 'static',windowClass: 'backgroundTransparent  approvalinfo'});
    this.modalRef.componentInstance.singleyear = year;
    console.log("window extension",this.windowdata);
    this.modalRef.componentInstance.windowdata = this.windowdata;
    this.modalRef.result.then((result) => {
      console.log(result)
      if(result == 'load')
        this.getWindowStatus();
    }, (reason) => {
  
    });
  }
  deletewindow(year){
    let postdata = {};   
    let yr=year.split("#");

    postdata['view'] = this.constants.VIEWS['admin'],
    postdata["cType"] =  this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
    postdata['ay'] =  yr[0];
    postdata['subTp']=yr[1];
    if(this.userdetails['roles'][0] == 'DISTRICT_NODAL_OFFICER'){
      postdata["lu"]  = this.userdetails['loggedUserData']['userProfile']['locationId']
      }
      console.log("delete post params",postdata)
    if (confirm("Are you sure to delete this window?")) {
      this.activeSpinner = true;
      this.submitdataservice.deletewindow(postdata).subscribe(data =>{
        if(data.status){
          this.toastr.success(data['msg']);
          this.getWindowStatus();
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while deleting window")
        }
        this.activeSpinner = false
      });
    }
  }
  basicvalidationforsetwindow(){
    this.validation[2] = this.utils.checkfield(this.setwindowparams['assessmentyear']);
    // this.validation[3] = this.utils.checkarrayfield(this.setwindowparams['statearray']);
    this.validation[4] = this.utils.checkfield(this.setwindowparams['sdate']);
    this.validation[5] = this.utils.checkfield(this.setwindowparams['edate'])
    return this.validation[2]  && this.validation[4] && this.validation[5]
  }

}
